<script setup lang="ts">
import AuthMessage from "@/cms/components/SiteSwitcher/AuthMessage.vue";
import { useHttpStore } from "@/stores/http/index.ts";
import { isCustomDomain, HOSTNAMES } from "@/util/hostnames.ts";
import { gtagQuery } from "@/util/gtagHelpers.js";
import { useRoute } from "vue-router";
import { onMounted, computed } from "vue";

defineOptions({
  layout: "utility",
});

const httpStore = useHttpStore();
const route = useRoute();

const label = computed(() => {
  if (window.location.search.includes("fromLogout=true")) {
    return "Logged out successfully! Redirecting...";
  }

  return "Starting secure session...";
});

onMounted(async () => {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get("fromLogout") === "true") {
    if (searchParams.get("styleid")) {
      window.location.href = `/home/${searchParams.get("styleid")}`;
    } else {
      window.history.back();
    }
    return;
  }

  if (isCustomDomain()) {
    window.location.href = `https://${HOSTNAMES.production}/login`;
    return;
  }

  setTimeout(async () => {
    gtagQuery("cms_login", {
      event_category: "Login",
      event_label: "CMS",
    });

    const { styleid } = route.params;

    await httpStore.auth0Client.loginWithRedirect({
      appState: {
        target: styleid ? `/home/${styleid}` : "/post-redirect/lookup",
      },
    });
  }, 300);
});
</script>

<template>
  <AuthMessage :label />
</template>
